import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from '../services/api';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

function Analytics() {
  const [analysisData, setAnalysisData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchWithAuth('/api/data/analytics/utility-allowances');
        const data = await response.json();
        
        if (data.error) {
          setError(data.error);
        } else {
          setAnalysisData(data);
        }
      } catch (err) {
        setError('Failed to fetch utility allowance analysis data');
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading utility allowance analysis...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (!analysisData) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>No utility allowance analysis data available</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Utility Allowance Analysis
        </Typography>
        <Typography>
          Total leases analyzed: {analysisData.summary.total_leases_analyzed}
        </Typography>
        <Typography>
          Leases with valid data: {analysisData.summary.total_with_valid_data}
        </Typography>
      </Paper>

      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Results by Payment Standard Effective Date
        </Typography>
        {Object.entries(analysisData.effective_dates)
          .sort(([dateA], [dateB]) => new Date(dateA) - new Date(dateB))
          .map(([date, bedroomData]) => (
            <Box key={date} sx={{ mb: 4 }}>
              <Typography variant="subtitle1" sx={{ mb: 2 }}>
                Effective Date: {date}
              </Typography>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Bedroom Count</TableCell>
                      <TableCell align="right">Average Delta</TableCell>
                      <TableCell align="right">Median Delta</TableCell>
                      <TableCell align="right">Sample Count</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.entries(bedroomData)
                      .sort(([a], [b]) => a.localeCompare(b))
                      .map(([bedroom, data]) => (
                        <TableRow key={bedroom}>
                          <TableCell>{bedroom}</TableCell>
                          <TableCell align="right">
                            ${data.average_delta.toFixed(2)}
                          </TableCell>
                          <TableCell align="right">
                            ${data.median_delta.toFixed(2)}
                          </TableCell>
                          <TableCell align="right">
                            {data.sample_count}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ))}
      </Paper>
    </Box>
  );
}

export default Analytics; 